// useCountdown (services/CountDown.ts) returns [years, months, days, hours, minutes, seconds] as
// strings. This turns that into the compact "1d 2h 3m 4s" the settlement and covenant cards set in
// mono next to their status sentence, and "" once the target has passed — so callers can use the
// empty string as "the window has closed". Lifted out of SettlementPanel so CovenantChallengePanel
// can count down a review window the same way.
export const formatCountdown = (parts: string[]): string => {
  if (parts.length < 6) {
    return "";
  }
  const [, , days, hours, minutes, seconds] = parts.map(Number);
  if ([days, hours, minutes, seconds].some((n) => Number.isNaN(n)) || days + hours + minutes + seconds <= 0) {
    return "";
  }
  const chunks: string[] = [];
  if (days > 0) {
    chunks.push(`${days}d`);
  }
  if (hours > 0) {
    chunks.push(`${hours}h`);
  }
  chunks.push(`${minutes}m ${seconds}s`);
  return chunks.join(" ");
};
